module.exports = __webpack_public_path__ + "static/media/autometrics-logo.4690d8b2.png";